import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from 'projects/visa-platform/src/environments/environment';
import { Environment } from 'projects/visa-platform/src/environments/environment.interface';

import { CommonAnchorComponent } from '../common-anchor/common-anchor.component';

@Component({
  selector: 'visa-platform-footer',
  imports: [CommonModule, CommonAnchorComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  public currentYear = new Date().getFullYear();
  public env: Environment = environment;
}
